<template>
  <div class="modal">
    <div class="modal__background" @click.stop="closeModal"></div>
    <div class="modal__content" :class="{[type]:true, 'no-title':noTitle, 'no-title-top':noTitleTop}">
      <div class="modal__content__header">
        <template v-if="!hideClose">
          <button v-if="noTitle || noTitleTop" @click.stop="closeModal" class="btn-no-title"><i class="icon-close"></i></button>
          <button v-else @click.stop="closeModal"><i class="icon-close"></i></button>
        </template>
        <div class="title large-font">{{title}}</div>
      </div>
      <slot name="content" />
    </div>
  </div>
</template>

<script>
import Media from 'vue-media'

export default {
  name: 'adx-modal',
  components: {
    Media
  },
  props: {
    type: {
      required: false
    },
    title: {
      required: false
    },
    color: {
      required: false
    },
    noTitle: {
      required: false,
      default: false
    },
    noTitleTop: {
      required: false,
      default: false
    },
    hideClose: {
      required: false,
      default: false
    }
  },
  watch: {

  },
  beforeCreate(){
    
  },
  mounted() {
    document.body.style.overflow = "hidden"
    document.documentElement.style.overflow = "hidden"
    document.body.style.position = "relative" 
    document.documentElement.style.overflow = "relative"
    document.body.style.height = "100%" 
    document.documentElement.style.height = "100%"
    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.closeModal()
      }
    })
    
  },
  destroyed() {
    document.body.style.overflow = '' 
    document.documentElement.style.overflow = ''
    document.body.style.position = '' 
    document.documentElement.style.overflow = ''
    document.body.style.height = '' 
    document.documentElement.style.height = ''
  },
  methods: {
    closeModal() {
      this.$emit('modal-close')
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>